var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamcorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camcorder_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".camcorder_svg__cls-1{stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "camcorder_svg__cls-1",
    d: "M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0zm0 31C7.72 31 1 24.28 1 16S7.72 1 16 1s15 6.72 15 15-6.72 15-15 15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "camcorder_svg__Path_1100",
    "data-name": "Path 1100",
    className: "camcorder_svg__cls-1",
    d: "M25.03 11.13a.363.363 0 00-.4 0l-2.8 2.16v-.96c0-1.28-1.04-2.32-2.32-2.32H9.19c-1.28 0-2.32 1.04-2.32 2.32v7.2c0 1.28 1.04 2.32 2.32 2.32h10.32c1.28 0 2.32-1.04 2.32-2.32v-.96l2.8 2.16c.12.08.28.08.4 0 .16-.08.24-.16.24-.32v-8.96c0-.16-.08-.24-.24-.32z"
  })));
}

export default __webpack_public_path__ + "b02e33943ddf8edfcfac23c3707c03ef.svg";
export { SvgCamcorder as ReactComponent };